import util from '@bmp-vue/core/api/util'

const controller = 'ItemsCustomizados'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  ListReferenciaByPortalAndStatus: function (dto) {
    return util.Axios.Post(controller + '/ListReferenciaByPortalAndStatus', dto)
  },
})
